import { metricConversionRates } from '@/constants';

const convertMilesToMeters = (miles: number) => miles * metricConversionRates.mileToMeter;
const convertMetersToMiles = (meters: number) => meters / metricConversionRates.mileToMeter;
const convertMilesToKilometers = (miles: number) => miles * metricConversionRates.mileToKilometer;
const convertKilometersToMiles = (kilometers: number) => kilometers / metricConversionRates.mileToKilometer;
const convertKilometersToFeet = (kilometers: number) => kilometers * metricConversionRates.kilometerToFoot;
const convertFeetToKilometers = (feet: number) => feet / metricConversionRates.kilometerToFoot;
const convertMetersToFeet = (meters: number) => meters * metricConversionRates.meterToFoot;
const convertFeetToMeters = (feet: number) => feet / metricConversionRates.meterToFoot;
const convertImperialTonsToMetricTons = (imperialTons: number) =>
  imperialTons * metricConversionRates.imperialTonToMetricTon;
const convertMetricTonsToImperialTons = (metricTons: number) => metricTons / metricConversionRates.imperialTonToMetricTon;
const convertCubicMetersToCubicYards = (cubicMeters: number) => cubicMeters * metricConversionRates.cubicMeterToCubicYard;
const convertCubicYardsToCubicMeters = (cubicYards: number) => cubicYards / metricConversionRates.cubicMeterToCubicYard;
const covertCubicYardsToImperialTons = (cubicYards: number, customConversionRate?: number) =>
  cubicYards * (customConversionRate ?? metricConversionRates.generalCubicYardToImperialTon);
const convertImperialTonsToCubicYards = (imperialTons: number, customConversionRate?: number) =>
  imperialTons / (customConversionRate ?? metricConversionRates.generalCubicYardToImperialTon);

export const useMetricConverters = () => ({
  convertMilesToMeters,
  convertMetersToMiles,
  convertMilesToKilometers,
  convertKilometersToMiles,
  convertKilometersToFeet,
  convertFeetToKilometers,
  convertMetersToFeet,
  convertFeetToMeters,
  convertImperialTonsToMetricTons,
  convertMetricTonsToImperialTons,
  convertCubicMetersToCubicYards,
  convertCubicYardsToCubicMeters,
  covertCubicYardsToImperialTons,
  convertImperialTonsToCubicYards
});
